export default __webpack_public_path__ + "static/doug-0ce8b652a38b8677f546fee0387a602e.jpg";